import React from 'react'
import createToolbarPlugin from 'draft-js-static-toolbar-plugin'
import PropTypes from 'prop-types'
import ToolbarButtons from './ToolbarButtons'
import buttonStyles from './buttonStyles.module.css'
import 'draft-js-static-toolbar-plugin/lib/plugin.css'

const toolbarTheme = {
  buttonStyles,
  toolbarStyles: {}
}

export const toolbarPlugin = createToolbarPlugin({ theme: toolbarTheme }) // Use CSS Module to theme custom buttons
const { Toolbar: PluginToolbar } = toolbarPlugin // We need to wrap the ToolbarButtons in the Toolbar component we get from createToolbarPlugin
export const Toolbar = ({ onLinkButtonClick, onFileUploadClick }) => (
  <PluginToolbar>
    {externalProps => <ToolbarButtons onLinkButtonClick={onLinkButtonClick} onFileUploadClick={onFileUploadClick} {...externalProps} />}
  </PluginToolbar>
)

export default () => {
  const toolbarPlugin = createToolbarPlugin({ theme: toolbarTheme }) // Use CSS Module to theme custom buttons
  const { Toolbar: PluginToolbar } = toolbarPlugin // We need to wrap the ToolbarButtons in the Toolbar component we get from createToolbarPlugin
  const ToolbarComponent = ({ onLinkButtonClick, onFileUploadClick }) => (
    <PluginToolbar>
      {externalProps => <ToolbarButtons onLinkButtonClick={onLinkButtonClick} onFileUploadClick={onFileUploadClick} {...externalProps} />}
    </PluginToolbar>
  )
  return { ToolbarComponent, toolbarPlugin }
}

Toolbar.propTypes = {
  onLinkButtonClick: PropTypes.func.isRequired
}
